import classNames from 'classnames';
import useLayout from 'hooks/use-layout';
import type { ReactNode } from 'react';
import { useMemo } from 'react';
import type { TextBlockSize } from 'types/components/text-block';
import type { Layout } from 'types/layout';
import { validateString } from 'utils/validate-string';

import styles from './text-block.module.scss';

interface UseTextBlockOptions {
  readonly callsToAction: ReactNode | undefined;
  readonly size: TextBlockSize;
  readonly layout: Layout;
}

interface UseTextBlockResult {
  displayCta: boolean;
  rootClass: string;
}

const contentClass = validateString(styles.content);

export default function useTextBlock({
  callsToAction,
  size,
  layout,
}: UseTextBlockOptions): UseTextBlockResult {
  const layoutClass = useLayout({
    layout,
    styles,
  });

  return {
    displayCta: typeof callsToAction !== 'undefined',

    rootClass: useMemo(() => {
      return classNames(
        contentClass,
        layoutClass,
        validateString(styles[`size-${size}`]),
      );
    }, [size, layoutClass]),
  };
}
